<template>
<div v-if="!this.$store.state.general.user.verified">
      <plans msgtitle="You currently do not have access to 360 Overview"
            msgdescription="Please choose a plan to pay to enjoy the 360 Overview feature"
      ></plans>
    </div>
  <div v-else>
    <b-card>
      <b-row>
        <b-col cols :md=4>
          <h5>Step 1: Select database</h5>
          <b-form-select
            v-model="database_"
            :options="databases"
            
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            ></b-form-select>
        </b-col>
        <b-col v-if="database_ != null" cols :md=4>
          <h5>Step 1: Select table to view 360</h5>
          <b-form-select
            v-model="collection_"
            :options="collections"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            ></b-form-select>
        </b-col>
      </b-row>      
    </b-card>

    <div class="p-2">
      <customer-list-section v-if="rawFile != null && database_ != null" :key="collection_"
        active
        :filter="filter"
        :raw-file="rawFile"
        :dataType="rawFile['originalName'].indexOf('.csv') > -1 ? rawFile['_id'] : rawFile['originalName']"
        :database="database_"
        disable-download
        :disable-sort="false"
        />

    
    </div>
  </div>
</template>

<script>
  import CustomerSummaryView from './CustomerSummaryView';
  import TabView from './TabView';
  import Plans from '../Plans/Plans'
  import CustomerListSection from '../Insights/CustomerListSection';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;
  export default {
    name: 'SidebarTo360',
    components: {
      CustomerSummaryView,
      TabView,
      CustomerListSection,
      Plans
    },
    // watch: {
    //   "$route.params.id"(id) {
    //     this.customerID = id;
    //   },
    //   "$route.params.collection"(col) {
    //     this.collection_ = col;
    //   }
    // },
 
    created(){
        // this.collections = this.$store.state.files.collections;
        this.database_ = this.null;
        this.collection_ = this.collections[0];
    },
  
    data() {
     
      return {
        customerID: this.$route.params.id,
        // collections: null,
        // databases: null,
        collection_: null,
        database_: null,
        rawFile: null,
        filter: {
          method: "dynamic",
          values: {
            logic: "and",
            filters: []
          }
        }
      };
    },
   computed: {
      collections(){
        //  return this.$store.state.files.collections;
        var collections = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.originalName && file.database === this.database_ && !collections.includes(file.originalName)) {
            collections.push(file.originalName);
          }
        });
        return collections;
      },

      databases() {
        var databases = [];
        this.$store.state.files.fileList.forEach(file => {
          if (!!file.database && !databases.includes(file.database)) {
            databases.push(file.database);
          }
        });
        return databases;
      },

      raw_files() {
        // let keyIs = {'database': null, 'originalName': 'key insights'};
        // return [keyIs].concat(this.F);
        this.F.forEach(x => {
          this.idList.push(x['id']);
        });
        return this.F;
      },
    
      options(){
           return this.collections.map( e =>({
               item: e,
               name: e
           }))
       }
   },

    watch: {
      collection_: function(val) {
        if (!!val) {
          this.$store.state.files.fileList.forEach(file => {
            // var col_name = this.getCollection(file);
            if (file.database === this.database_ && file.originalName === this.collection_) {
              this.rawFile = file;
            }
          });
        }
      }
    }
    
  };
</script>

<style scoped>
  .search {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid var(--brand-primary-color);
  }
</style>